<span class="text-xs font-medium text-foreground-primary-60 min-w-[92px]">{{ 'sites.mobile-site-card.at-a-glance' | translate }}</span>

<div class="flex grow pb-[3px] min-w-0">
  @let vehiclesPerState = vm().vehiclesPerState;
  @let evsesPerState = vm().evsesPerState;

  @if (vehiclesPerState) {
    <app-sites-table-vehicles-per-state-cell class="grow min-w-0" [vehiclesPerState]="vehiclesPerState" />
  } @else if (evsesPerState) {
    <app-sites-table-evses-per-state-cell class="grow min-w-0" [evsesPerState]="evsesPerState" />
  }
</div>
